'use strict';

var _ = require('lodash');
var $ = require('jquery');
var PubSub = require('tscom-pubsub');
var template = require('../templates/auth.ejs');
var APP_CONST = require('../constants').app;

var AuthView = require('standard-vote/app/scripts/views/auth');

module.exports = AuthView.extend({
    events: function(){
        return _.extend({},AuthView.prototype.events,{
            'keyup #email': 'handleEmail',
            'click .socialBox.email': 'triggerEmailContainer'
        });
    },

    triggerEmailContainer: function() {
        $('.email-address').focus();
        $(document).delegate('.email-address', function (e) {
            if (e.target.id) {
                window.location.hash = e.target.id;
            }
        });
    },

    storeOptins: function() {
        // they are prefixed with 'optin_'
        $.each(this.$el.find('form [type=checkbox]'), _.bind(function(i, el) {
            var evt = {
                target: this,
                name: 'eventClickOptin',
                origEvent: 'optin_' + $(el).attr('name')
            };
            this.trigger('trackEvent',evt);
            localStorage['optin_' + $(el).attr('name')] = $(el).prop('checked');
        }, this));

    },

    emailSignin: function(e) {
        e.preventDefault();

        var validOptins = $.fn.h5Validate.call( this.$('.optin-form'), 'allValid' );
        var validEmail = $.fn.h5Validate.call( this.$('#emailAuthForm'), 'allValid' );

        if(!validOptins) {
            $('.terms-label').addClass('terms-invalid');
            return;
        }

        if (validEmail) {
            var email = this.$('#email').val();
            this.storeOptins();
            this.auth.signInSuccess('email', email);

            var evt = {
                category: 'Button Click',
                action: 'Button Click: Login Email',
                label: 'Button Click: Login Email'
            };

            PubSub.trigger('modal:close');
            PubSub.trigger('trackGoogle',evt);
        }
    },

    fbSignin: function(e) {
        e.preventDefault();

        if($(e.currentTarget).hasClass('eliminated')) return;

        if( $.fn.h5Validate.call( this.$( '.optin-form' ), 'allValid' ) ){
            this.facebook.isConnected(this.fbSignInResponse.bind(this));
            PubSub.trigger('route:loading','facebook');
        } else {
            $('.terms-label').addClass('terms-invalid');
        }
    },

    fbSignInResponse: function(response) {

        if (response) {
            this.storeOptins();
            this.router.closeCurrentModal();
            this.auth.signInSuccess('facebook');

            var evt = {
                category: 'Button Click',
                action: 'Button Click: Login Facebook',
                label: 'Button Click: Login Facebook'
            };

            PubSub.trigger('trackGoogle',evt);
        } else {
            PubSub.trigger('route:auth');
        }
    },

    render: function() {

        this.createModel();

        var params = {
            emailMaxLength: APP_CONST.EMAIL_MAX_LENGTH,
            text: this.model.text,
            terms: this.cms.get('text').views_page_footer
        };

        this.$el.html(template(params));

        $.fn.h5Validate.call( this.$( '.optin-form' ) );
        $.fn.h5Validate.call( this.$( '#emailAuthForm' ) );

        _.each(this.$('.checkbox-parent'), function(el) {
            var $faux = $(el).find('.faux-box');
            var $checkbox = $(el).find('[type=\'checkbox\']');
            if ($checkbox.is(':checked')) {
                $faux.addClass('checked');
                $checkbox.prop('checked', true);
            }
        });

        return this;
    },

    activeSubmit: _.debounce(function(e) {
        var valid = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test( e.target.value );
        this.$('#submitEmailAuth').attr('disabled', !valid);
        valid ? this.$('#submitEmailAuth').removeClass('eliminated') : this.$('#submitEmailAuth').addClass('eliminated');

        if(!valid) this.$('.email-address').addClass('email-invalid');
        else this.$('.email-address').removeClass('email-invalid');
    },50),

    toggleCheck: function(e) {
        if($('#terms').prop('checked')) $(e.currentTarget).addClass('terms-invalid');
        else $(e.currentTarget).removeClass('terms-invalid');
    },

    handleEmail: function() {
        var email = $('#email');
        var emailVal = email.val();
        var max = APP_CONST.EMAIL_MAX_LENGTH;

        if(emailVal.length > max){
            emailVal = emailVal.slice(0,max);
            email.val(emailVal);
        }
    }
});



// WEBPACK FOOTER //
// ./app/scripts/views/auth.js